import Axios from "axios";
import { Response } from "@konv/http";

Axios.defaults.headers.common["Content-Type"] = "application/json";
Axios.defaults.headers.common["Accept"] =
  "application/json, text/plain, text/html";

Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return error;
  }
);

export const APIRequest = async ({
  service,
  endpoint,
  method,
  data,
  params,
  headers,
}) => {
  const sUrl = `${process.env.REACT_APP_SERVICES_ENDPOINT_BASE.replace(
    `{SERVICE}`,
    `olga/request/${service}`
  )}${endpoint}`;
  try {
    const doRequest = async () => {
      const response = await Axios.request({
        url: sUrl,
        crossdomain: true,
        method: method || "GET",
        data: data || {},
        params: params || {},
        headers: headers || {},
      });
      return response;
    };

    let req = null;
    let tries = 0;
    const maxTries = 3;

    while (tries < maxTries) {
      req = await doRequest();
      
      if (
        (
          !req?.data?.response?.errors?.length &&
          !req?.data?.errors?.length
        )
        || req?.data?.response?.code === 1006
        || req?.data?.code === 1006
      ) {
        break;
      }  
      tries++;
    }

    const response = req;

    if (response.data?.response) {
      return new Response(
        response.data.response.data || null,
        response.data.response.code || 200,
        response.data.response.errors || []
      );
    } else if (response.data?.code) {
      return new Response(
        response.data.data || null,
        response.data.code || 200,
        response.data.errors || []
      );
    }

    return new Response(
      response.data?.data || null,
      response.data?.code || 200,
      response.data?.errors || []
    );
  } catch (err) {
    console.log(err);
  }
};
/* eslint-enable */
